// Listing-request lifecycle enums. The listing-request state machine is
// documented in admin-service `docs/listing-requests-admin-api.md §2`.
//
// The admin portal drives: submitted → agreement_in_progress, with reject /
// request-revision branches. Verifying the declared owners happens inside
// `submitted` and is a precondition of approving — not a status of its own.
// Statuses with no admin action yet (owners onboarding, promoted) still get a
// queue — read-only — so the operator can see them; `draft` / `under_review` /
// `approved` / `owner_verification` get none. See `listingRequestQueues.ts` for
// the status → queue mapping and why.

export enum LISTING_REQUEST_STATUS {
  DRAFT = 'draft',
  SUBMITTED = 'submitted',
  REVISION_REQUESTED = 'revision_requested',
  REJECTED = 'rejected',
  AGREEMENT_IN_PROGRESS = 'agreement_in_progress',
  WITHDRAWN = 'withdrawn',
  // Retired or not-yet-reached — never entered by the admin flow today. Kept
  // because the BE enum keeps them (dropping a Postgres enum value means
  // recreating the type) and a request frozen at one by an older release must
  // still render.
  UNDER_REVIEW = 'under_review',
  APPROVED = 'approved',
  OWNER_VERIFICATION = 'owner_verification',
  AGREEMENT_REJECTED = 'agreement_rejected',
  AGREEMENT_COMPLETED = 'agreement_completed',
  OWNERS_ONBOARDING = 'owners_onboarding',
  PROMOTED = 'promoted',
}

export enum PRICE_NEGOTIATION_STATUS {
  NONE = 'none',
  PROPOSED = 'proposed',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export enum OWNERSHIP_ROLE {
  SOLE_OWNER = 'sole_owner',
  CO_OWNER = 'co_owner',
  REAL_ESTATE_AGENT = 'real_estate_agent',
  AUTHORISED_REPRESENTATIVE = 'authorised_representative',
}

// Which statuses each queue surfaces now lives in the queue registry
// (`listingRequestQueues.ts`) — one row per queue instead of a single
// default-queue constant.

/**
 * The two attachments a seller uploads at intake, held inline on the request.
 *
 * Values are the kebab-case wire path segments the download-url endpoint accepts
 * — NOT the snake_case `property_document_type` these become once the request is
 * promoted into a property.
 */
export enum LISTING_REQUEST_DOCUMENT_TYPE {
  TITLE_DEED = 'title-deed',
  RENTAL_AGREEMENT = 'rental-agreement',
}
